/** Where an interrupted sign-in is sent back to, as a query parameter. */
export const NEXT_PARAM = 'next'

/** The route an authenticated user lands on with nothing else asked for. */
export const DEFAULT_HOME = '/seo'

/**
 * Only a same-origin path may be returned to.
 *
 * `?next=https://evil.example/` on a sign-in page is an open redirect, and one
 * on a sign-in page is worth more to an attacker than most: the victim has just
 * typed a password and will not look hard at the address bar afterwards.
 *
 * Only a value beginning with a single `/` is accepted. `//host` is rejected
 * because a browser reads it as protocol-relative — a fully qualified URL
 * wearing a path's clothing, and the case a naive `startsWith('/')` misses.
 */
export function safeNext(value: string | null): string | null {
  if (!value?.startsWith('/') || value.startsWith('//')) return null
  return value
}

/** `?next=` appended to a path, encoded once. */
export function withNext(path: string, next: string): string {
  return `${path}?${NEXT_PARAM}=${encodeURIComponent(next)}`
}
